import { IonPage, IonHeader, IonContent, IonIcon } from '@ionic/react'
import React from 'react'
import { useHistory } from 'react-router'
import './login-wallet.css'
import AppHeader from '../../components/AppHeader/AppHeader'
import { useTranslation } from 'react-i18next'
import { mailOutline, callOutline, logInOutline } from 'ionicons/icons'
import { useAppDispatch, useAppSelector } from '../../services/redux/hook'
import { createStellarKeys } from '../../services/stellar/stellar-utils'
import { setFlowContext, setWalletInfo } from '../../services/redux/slices'

const LoginWalletPage: React.FC = () => {

    const history = useHistory();
    const { t, i18n } = useTranslation();
    const walletInfo = useAppSelector((state) => state.walletInfo);
    const dispatch = useAppDispatch();

    const emailConfirm = () => {
        //creating here the device public and private key
        const [device_public_key, device_master_key] = createStellarKeys();
        const newWalletInfo = { ...walletInfo };
        newWalletInfo.device_key = device_public_key;
        newWalletInfo.device_private_key = device_master_key;

        //this needs to be replaced by the actual account key during the login
        //in the LoginEmail Verify
        newWalletInfo.account_key = device_public_key;
        newWalletInfo.account_private_key = device_master_key;

        dispatch(setWalletInfo(newWalletInfo));
        dispatch(setFlowContext({ 
            flow: 'login', 
            redirectAfterPin: '/login/email' 
        }));

        history.push('/pin/create');
    }

    const phoneConfirm = () => {
        history.push('/login/phone')
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <AppHeader
                    title={t('login.wallet.page.HEADER') as string}
                    goBack={true}
                />
            </IonHeader>

            <IonContent scrollY={false} className="recover-wallet-content">
                {/* Hero Section */}
                <div className="hero-section">
                    <div className="hero-content">
                        <div className="icon-wrapper">
                            <IonIcon
                                icon={logInOutline}
                                className="hero-icon"
                            />
                        </div>
                        <h1 className="hero-title">
                            {t('login.wallet.page.TITLE')}
                        </h1>
                        <p className="hero-description">
                            {t('login.wallet.page.SUBTITLE')}
                        </p>
                    </div>
                </div>

                {/* Recovery Options */}
                <div className="recovery-options">
                    {/* Email Recovery Option */}
                    <div className="recovery-option-card">
                        <button
                            onClick={emailConfirm}
                            className="recovery-option-button"
                        >
                            <div className="option-content">
                                <div className="option-icon-wrapper email-icon">
                                    <IonIcon
                                        icon={mailOutline}
                                        className="option-icon"
                                    />
                                </div>
                                <div className="option-text">
                                    <h3 className="option-title">
                                        {t('login.wallet.page.EMAIL-CONTINUE-LABEL')}
                                    </h3>
                                    <p className="option-description">
                                        {t('login.wallet.page.EMAIL_DESCRIPTION')}
                                    </p>
                                </div>
                                <div className="option-arrow">
                                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    </div>

                    {/* Phone Recovery Option */}
                    <div className="recovery-option-card">
                        <button
                            onClick={phoneConfirm}
                            className="recovery-option-button"
                        >
                            <div className="option-content">
                                <div className="option-icon-wrapper phone-icon">
                                    <IonIcon
                                        icon={callOutline}
                                        className="option-icon"
                                    />
                                </div>
                                <div className="option-text">
                                    <h3 className="option-title">
                                        {t('login.wallet.page.PHONE-CONTINUE-LABEL')}
                                    </h3>
                                    <p className="option-description">
                                        {t('login.wallet.page.PHONE_DESCRIPTION')}
                                    </p>
                                </div>
                                <div className="option-arrow">
                                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

            </IonContent>
        </IonPage>
    )
}

export default LoginWalletPage
